/**
 * Runtime configuration, read once from Vite env vars. See `.env.example`.
 */
function flag(value: string | undefined): boolean {
  return value === 'true' || value === '1'
}

/** Mock identity: an FPA role, `none` (403 everywhere) or `signed-out` (shows the sign-in screen). */
export type MockRole = 'admin' | 'manager' | 'viewer' | 'none' | 'signed-out'

const MOCK_ROLES: readonly MockRole[] = ['admin', 'manager', 'viewer', 'none', 'signed-out']

function mockRole(value: string | undefined): MockRole {
  return MOCK_ROLES.find((role) => role === value) ?? 'admin'
}

export type AppEnv = 'prod' | 'qa' | 'local'

function appEnv(value: string | undefined): AppEnv {
  return value === 'prod' || value === 'qa' ? value : 'local'
}

function trimSlash(url: string): string {
  return url.replace(/\/+$/, '')
}

export const env = {
  apiUrl: trimSlash(import.meta.env.VITE_API_URL ?? 'http://localhost:8787'),
  identityUrl: trimSlash(import.meta.env.VITE_IDENTITY_URL ?? 'https://identity.rbiprivatelending.com'),
  /** Deploy target baked in by CodeBuild (`qa` | `prod`); anything else is a local build. */
  appEnv: appEnv(import.meta.env.VITE_APP_ENV),
  useMocks: flag(import.meta.env.VITE_USE_MOCKS),
  mockRole: mockRole(import.meta.env.VITE_MOCK_ROLE),
  /** Local backend with AUTH_DEV_BYPASS: no login, no bearer. Never honoured in production builds. */
  authBypass: import.meta.env.DEV && flag(import.meta.env.VITE_AUTH_BYPASS),
} as const

/** True when the SPA should not run the identity login flow at all. */
export const authDisabled = env.useMocks || env.authBypass

/** The signed-in email the mock "no access" screen shows (`VITE_MOCK_ROLE=none`). */
export const MOCK_NO_ACCESS_EMAIL = 'jordan.doe@rbialliance.com'

/** Mock mode previewing the signed-out screens (`VITE_MOCK_ROLE=signed-out`). */
export const mockSignedOut = env.useMocks && env.mockRole === 'signed-out'
